import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-65463aba"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50"
};
const _hoisted_2 = { class: "modern-banner" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M18 6L6 18M6 6L18 18",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })
], -1));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modern-spinner" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.showBanner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                (!_ctx.showAnimation)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "close-button",
                        "aria-label": "Fermer",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.close && _ctx.close(...args)))
                    }, _hoisted_4))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass(["banner-content", { 'no-close-button': _ctx.showAnimation }])
                }, [
                    _renderSlot(_ctx.$slots, "dynamic-content", {}, undefined, true),
                    (_ctx.showAnimation)
                        ? _renderSlot(_ctx.$slots, "spinner", { key: 0 }, () => [
                            _hoisted_5
                        ], true)
                        : _createCommentVNode("", true)
                ], 2)
            ])
        ]))
        : _createCommentVNode("", true);
}
